import * as React from 'react';
import classnames from 'classnames';
import Base, { Props as BaseProps } from '../Base/Base';

export interface Props extends BaseProps {
  /** @Ignore */
  onClick?: () => void;
}

/**
 * The row that holds the TableCell components. Should be
 * a direct descendant of the TableBody component.
 */
const TableRow: React.FunctionComponent<Props> = (props: Props) => {
  const { onClick, ...rest } = props;
  const classes = classnames('Table__row', {
    'Table__row--clickable': onClick,
  });

  return (
    <Base { ...rest }
        Component="tr"
        className={ classes }
        onClick={ onClick } />
  );
};

export default TableRow;
